export const LANGUAGES = [
    {
        label: 'Thai',
        value: 'TH',
    },
    {
        label: 'English',
        value: 'EN',
    },
    {
        label: 'Moldavian',
        value: 'MO',
    },
    {
        label: 'Somali',
        value: 'SO',
    },
    {
        label: 'Croatian',
        value: 'HR',
    },
    {
        label: 'Mauritian Creole',
        value: 'MFE',
    },
    {
        label: 'Armenian',
        value: 'HY',
    },
    {
        label: 'Hindi',
        value: 'HI',
    },
    {
        label: 'Dutch',
        value: 'NL',
    },
    {
        label: 'Portuguese (Portugal)',
        value: 'PT-PT',
    },
    {
        label: 'Slovak',
        value: 'SK',
    },
    {
        label: 'Norwegian',
        value: 'NO',
    },
    {
        label: 'Malagasy',
        value: 'MG',
    },
    {
        label: 'Bengali',
        value: 'BN',
    },
    {
        label: 'Cambodian',
        value: 'KM',
    },
    {
        label: 'Bulgarian',
        value: 'BG',
    },
    {
        label: 'Belarusian',
        value: 'BE',
    },
    {
        label: 'Tonga',
        value: 'TO',
    },
    {
        label: 'Nepali',
        value: 'NE',
    },
    {
        label: 'Arabic',
        value: 'AR',
    },
    {
        label: 'Indonesian',
        value: 'ID',
    },
    {
        label: 'Kyrgyz',
        value: 'KY',
    },
    {
        label: 'Italian',
        value: 'IT',
    },
    {
        label: 'Korean',
        value: 'KO',
    },
    {
        label: 'Japanese',
        value: 'JA',
    },
    {
        label: 'Tigrinya',
        value: 'TI',
    },
    {
        label: 'Romanian',
        value: 'RO',
    },
    {
        label: 'Swahili',
        value: 'SW',
    },
    {
        label: 'Samoa',
        value: 'WS',
    },
    {
        label: 'Turkmen',
        value: 'TK',
    },
    {
        label: 'Portuguese',
        value: 'PT',
    },
    {
        label: 'Macedonian',
        value: 'MK',
    },
    {
        label: 'Mongolian',
        value: 'MN',
    },
    {
        label: 'Swedish',
        value: 'SV',
    },
    {
        label: 'Portuguese (Brazil)',
        value: 'PT-BR',
    },
    {
        label: 'Kazakh',
        value: 'KK',
    },
    {
        label: 'Maltese',
        value: 'MT',
    },
    {
        label: 'Montenegrin',
        value: 'SR-ME',
    },
    {
        label: 'Turkish',
        value: 'TR',
    },
    {
        label: 'Georgian',
        value: 'KA',
    },
    {
        label: 'Finnish',
        value: 'FI',
    },
    {
        label: 'Tajik',
        value: 'TG',
    },
    {
        label: 'Latvian',
        value: 'LV',
    },
    {
        label: 'Bosnian',
        value: 'BS',
    },
    {
        label: 'Albanian',
        value: 'SQ',
    },
    {
        label: 'Vietnamese',
        value: 'VI',
    },
    {
        label: 'Slovenian',
        value: 'SL',
    },
    {
        label: 'German',
        value: 'DE',
    },
    {
        label: 'Azerbaijani',
        value: 'AZ',
    },
    {
        label: 'French',
        value: 'FR',
    },
    {
        label: 'Hebrew',
        value: 'HE',
    },
    {
        label: 'Catalan',
        value: 'CA',
    },
    {
        label: 'Estonian',
        value: 'ET',
    },
    {
        label: 'Uzbek',
        value: 'UZ',
    },
    {
        label: 'Russian',
        value: 'RU',
    },
    {
        label: 'Seychellois Creole',
        value: 'CRS',
    },
    {
        label: 'Kirundi',
        value: 'RN',
    },
    {
        label: 'Myanmar',
        value: 'MY',
    },
    {
        label: 'Spanish',
        value: 'ES',
    },
    {
        label: 'Haitian Creole',
        value: 'HT',
    },
    {
        label: 'Bhutanese',
        value: 'BT',
    },
    {
        label: 'Filipino',
        value: 'TL',
    },
    {
        label: 'Greek',
        value: 'EL',
    },
    {
        label: 'Hungarian',
        value: 'HU',
    },
    {
        label: 'Sinhalese',
        value: 'SI',
    },
    {
        label: 'Danish',
        value: 'DA',
    },
    {
        label: 'Icelandic',
        value: 'IS',
    },
    {
        label: 'Lithuanian',
        value: 'LT',
    },
    {
        label: 'Amharic',
        value: 'AM',
    },
    {
        label: 'Serbian',
        value: 'SR',
    },
    {
        label: 'Pashto',
        value: 'PS',
    },
    {
        label: 'Czech',
        value: 'CS',
    },
    {
        label: 'Kinyarwanda',
        value: 'RW',
    },
    {
        label: 'Ukrainian',
        value: 'UK',
    },
    {
        label: 'Urdu',
        value: 'UR',
    },
    {
        label: 'Malay',
        value: 'MS',
    },
    {
        label: 'Polish',
        value: 'PL',
    },
    {
        label: 'Maldives',
        value: 'MV',
    },
    {
        label: 'Chinese (Simplified)',
        value: 'ZH-CN',
    },
    {
        label: 'Laothian',
        value: 'LO',
    },
];
